import Lenis from "lenis";

import { isMobile } from "../utils";

export class SmoothScroll {
  lenis?: Lenis;
  prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)")
    .matches;

  constructor() {
    if (!this.prefersReducedMotion && !isMobile()) {
      this.lenis = new Lenis({
        autoRaf: true,
        anchors: true,
        allowNestedScroll: true,
      });
    }
  }

  toggleLenisDocumentBodyScroll = (enabled: boolean) => {
    if (!this.lenis) {
      return;
    }

    document.body.toggleAttribute("data-lenis-prevent", !enabled);
  };
}
